import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Email } from '../shared/email.model';
import { MyLocalStorageService } from '../localstorage/mylocalstorage.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { formatDate } from "@angular/common";
import localeES from "@angular/common/locales/es";
import { AmazingTimePickerService } from 'amazing-time-picker';

export interface ora {
  value: string;
  viewValue: string;
}
export interface motivo {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-entrata-in-ritardo',
  templateUrl: './entrata-in-ritardo.component.html',
  styleUrls: ['./entrata-in-ritardo.component.scss'],
  providers: [{provide: MAT_DATE_LOCALE, useValue: 'it-IT'}]
})
export class EntrataInRitardoComponent implements OnInit {
  tiporichiesta:any;
  company: any;
  passwordFormControl = new FormControl('', [
    Validators.required
  ]);
  passwordFormControl1 = new FormControl('', [
    Validators.required
  ]);
  passwordFormControl2 = new FormControl('', [
    Validators.required
  ]);
  passwordFormControl3 = new FormControl('', [
    Validators.required
  ]);
  public variabile_orario: any;
  variabile_ora: any;
  variabile_motivo: any;
  variabile_data= new Date();
  setting: Email = new Email();
  ore: ora[] = [
    {value: '1', viewValue: '1'},
    {value: '2', viewValue: '2'},
    {value: '3', viewValue: '3'},
    {value: '4', viewValue: '4'}
  ];
  motivi: motivo[] = [
    {value: 'illness', viewValue: 'Illness'},
    {value: 'familiar', viewValue: 'Familiar'},
    {value: 'personal', viewValue: 'Personal'}
  ];
  constructor(private atp: AmazingTimePickerService, private _adapter: DateAdapter<any>, public _auth: AuthService, public _storage: MyLocalStorageService, private _router: Router,  private _service: NotificationsService) { }

  ngOnInit() {
    this.tiporichiesta=localStorage.getItem('tiporichiesta').replace(/_/g, " ");
    this.variabile_orario="08:30"
    this.company = localStorage.getItem('company');
    this._adapter.setLocale('it')
  }

 
  preview(){
    this._storage.setItem('data', this.variabile_data.toString());
    this._storage.setItem('ora', this.variabile_ora);
    this._storage.setItem('orario', this.variabile_orario);
    this._storage.setItem('motivo', this.variabile_motivo);
    this._router.navigate(['/preview'], { skipLocationChange: true });
  }
  open(ev: any) {
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe(time => {
      this.variabile_orario = time;
    });
  }
}
